// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"83":"1b4614c0","310":"1b4614c0","518":"5595bb7e","579":"5595bb7e","595":"6e48bdbd"}[chunkId] + ".chunk.css";
};